import { Subscribe, Container } from 'unstated';
import { Player } from "./player";
import { deriveScale } from "./ragas";
let swaras = deriveScale("G", 3);
let player = new Player(swaras);
export default class PlayerContainer extends Container {
    state = { 
        noteinText: [], 
        ragaSelected: null, 
        player: player, 
        swaras: swaras, 
        shruti: "G", 
        octave: 3,
        showMS: true,
        showTS: true,
        kaalam: 2
    };
    addSwara(s) {
        this.state.noteinText.push(s);
        this.setState({ noteinText: this.state.noteinText });
    }
    delSwara() {
        this.state.noteinText.pop();
        this.setState({ noteinText: this.state.noteinText });
    }
    clear() {
        this.setState({ noteinText: [] });
    }
    play() {
        this.state.player.play(this.state.noteinText);
    }
    stop() {
        this.state.player.stop();
    }
    setRaga(raga) {
        this.setState({ ragaSelected: raga, noteinText: raga.korvai.split(" ") });
    }

    setShruti(shruti) {
        let swaras = deriveScale(shruti, this.state.octave);
        this.setState({ shruti: shruti, swaras: swaras });
        player.swaras = swaras;
    }

    setOctave(octave) {
        let swaras = deriveScale(this.state.shruti, octave);
        this.setState({ octave: octave, swaras: swaras });
        player.swaras = swaras;
    }

    toggleShow() {
        this.setState({ showMS: !this.state.showMS});
    }
    toggleShowT() {
        this.setState({ showTS: !this.state.showTS});
    }

    setKaalam(k) {
        this.setState({kaalam: k});
        player.kaalam = k;
    }
}